import { t, type ErrorCodeMapperEntry } from "./types.js";

/** Error codes 24000-24999. One thousand-block per file: a duplicate number here can only
 *  collide within this file, which is what makes the split safer than one shared object. */
export const resourcesErrors = {
  // 24xxx is the resources module's series. Only two of its ~32 generic sites needed a new code:
  // thirteen shipped "Schedule does not exist" verbatim (now SCHEDULE_MISSING, 10002) and five used
  // the shared `VERSION_IN_PROGRESS_MSG` (now SCHEDULE_VERSION_OPERATION_IN_PROGRESS, 10013 — the
  // code created for exactly this constant, resources included). The remaining twelve stay generic:
  // they either literally say "Something went wrong" or forward a caught `error.message`.
  // 24001-24002 — the resources module's generic-code split.
  RESOURCE_SELECTION_SETS_AND_QUERIES_SAVE_FAILED: {
    errorCode: 24001,
    errorMessage: t("Selection sets and queries could not be saved."),
    isDynamic: false,
  },
  RESOURCES_DELETE_FAILED: {
    errorCode: 24002,
    errorMessage: t("The resources could not be deleted."),
    isDynamic: false,
  },
} satisfies Record<string, ErrorCodeMapperEntry>;
